module.exports = __webpack_public_path__ + "img/left-angle.a8751cb5.svg";